import { render, staticRenderFns } from "./ServeSearchView.vue?vue&type=template&id=d50343d2&scoped=true&"
import script from "./ServeSearchView.vue?vue&type=script&lang=js&"
export * from "./ServeSearchView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d50343d2",
  null
  
)

export default component.exports